const TITLE = "Join monday.com | Shape how the world works";
const DESCRIPTION = "Explore career opportunities to make an impact as we build AI-powered work products that people love to use.";
const META_OVERRIDE = {
    facebookMetaOverride: {
        imagePath: "https://s3.amazonaws.com/general-assets/careers/social-assets/monday-1200_628.png"
    },
    twitterMetaOverride: {
        imagePath: "https://s3.amazonaws.com/general-assets/careers/social-assets/monday-800_418.png"
    }
};
const POSITION_TYPE_CATEGORY_NAME = "Publish Position";
const POSITION_TYPE_INTERNAL = "internal";
const POSITION_TYPE_EXTERNAL = "external";
const POSITION_TYPE_ALL = "all"; // Show both internal and external positions
const POSITION_TYPE_INTERNAL_VALUE = "Internal Career Site";
const POSITION_TYPE_EXTERNAL_VALUE = "Monday Careers";
const POSITION_TYPE_INTERNAL_AND_EXTERNAL_VALUE = "Both";
const CAREERS_ROOT_URL = "/careers/";
const JOB_SOURCE_COMEET = "comeet";
const JOB_SOURCE_ASHBY = "ashby";
const ASHBY_API_BASE = "https://api.ashbyhq.com";
const ASHBY_APPLICATION_ROUTE = "/api/careers/ashby-application";
const ASHBY_RESUME_PARSE_ROUTE = "/api/careers/ashby-resume-parse";
const ASHBY_INTERNAL_PORTAL_URL = "https://app.ashbyhq.com/";
const CAREERS_CANDIDATES_PRIVACY_POLICY_URL = "https://monday.com/terms/candidates";
const RESUME_ACCEPTED_FORMATS = ".pdf,.doc,.docx";
const SEARCH_DEBOUNCE_RATE = 300;
// Location filter hidden per product request; kept implemented in case it needs to come back.
const SHOW_LOCATION_FILTER = false;
const getCareersRootUrl = (positionsType)=>{
    return CAREERS_ROOT_URL;
};
module.exports = {
    META_OVERRIDE,
    TITLE,
    DESCRIPTION,
    POSITION_TYPE_CATEGORY_NAME,
    POSITION_TYPE_INTERNAL,
    POSITION_TYPE_EXTERNAL,
    POSITION_TYPE_ALL,
    POSITION_TYPE_INTERNAL_VALUE,
    POSITION_TYPE_EXTERNAL_VALUE,
    POSITION_TYPE_INTERNAL_AND_EXTERNAL_VALUE,
    CAREERS_ROOT_URL,
    SEARCH_DEBOUNCE_RATE,
    SHOW_LOCATION_FILTER,
    JOB_SOURCE_COMEET,
    JOB_SOURCE_ASHBY,
    ASHBY_API_BASE,
    ASHBY_APPLICATION_ROUTE,
    ASHBY_RESUME_PARSE_ROUTE,
    ASHBY_INTERNAL_PORTAL_URL,
    CAREERS_CANDIDATES_PRIVACY_POLICY_URL,
    RESUME_ACCEPTED_FORMATS,
    getCareersRootUrl
};
